import React from 'react';
import { Users, Clock, Award, HeartHandshake } from 'lucide-react';
const benefits = [{
  title: 'Direct Founder Access',
  description: 'Work directly with experts who care about your success, not just account managers.',
  icon: Users
}, {
  title: 'Agile & Responsive',
  description: 'As a new, focused operation, we move faster than large bureaucratic molders.',
  icon: Clock
}, {
  title: 'Quality First',
  description: "We treat every part as if it were going into our own family's medical devices.",
  icon: Award
}, {
  title: 'Long-term Partners',
  description: 'We aim to grow with you. Your success is literally our business model.',
  icon: HeartHandshake
}];
export function Partnership() {
  return <section id="partnership" className="py-24 bg-white" data-id="element-349">
      <div className="container mx-auto px-4 md:px-6" data-id="element-350">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-351">
          <span className="text-accent font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-352">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-353">
            A Partnership Built on Trust & Transparency
          </h2>
          <p className="text-lg text-gray-600" data-id="element-354">
            Plastic Engineering Solutions was founded in 2024 to bring a higher
            level of personalized service to the precision injection molding
            industry. From complex medical components to high-volume industrial
            parts, we combine deep technical expertise with unwavering
            commitment to quality. We are big enough to deliver, but small
            enough to care.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-16" data-id="element-355">
          <div className="bg-gradient-to-br from-primary to-primary-dark rounded-2xl p-8 md:p-12 text-white text-center shadow-xl" data-id="element-356">
            <div className="mb-4" data-id="element-357">
              <div className="text-5xl md:text-7xl font-black mb-2" data-id="element-358">80M+</div>
              <div className="text-xl md:text-2xl font-medium text-blue-100" data-id="element-359">
                Caps Produced
              </div>
            </div>
            <p className="text-blue-100 max-w-2xl mx-auto" data-id="element-360">
              Our founder's proven track record in high-volume production
              ensures your project benefits from decades of hands-on
              manufacturing expertise.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-361">
          {benefits.map(benefit => <div key={benefit.title} className="flex flex-col items-center text-center p-6 rounded-xl bg-neutral-50 hover:bg-white hover:shadow-lg transition-all duration-300 border border-transparent hover:border-gray-100" data-id="element-362">
              <div className="p-4 bg-white rounded-full shadow-sm text-accent mb-6" data-id="element-363">
                <benefit.icon className="h-8 w-8" data-id="element-364" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-365">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-366">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}